/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Intro_P2_AfterInputs */

const es_gift_intro_p2_after = /** @type {(inputs: Gift_Intro_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` desde la compra. Compra online, recibe el código por email y listo para zarpar.`)
};

const gl_gift_intro_p2_after = /** @type {(inputs: Gift_Intro_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` desde a compra. Compra en liña, recibe o código por email e listo para zarpar.`)
};

const en_gift_intro_p2_after = /** @type {(inputs: Gift_Intro_P2_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` from purchase. Buy online, get the code by email and you're ready to sail.`)
};

/**
* | output |
* | --- |
* | "from purchase. Buy online, get the code by email and you're ready to sail." |
*
* @param {Gift_Intro_P2_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_intro_p2_after = /** @type {((inputs?: Gift_Intro_P2_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Intro_P2_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_intro_p2_after(inputs)
	if (locale === "en") return en_gift_intro_p2_after(inputs)
	return es_gift_intro_p2_after(inputs)
});